import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import image1 from "../assets/images/photo1.jpg"
import image2 from "../assets/images/photo2.jpg"
import image3 from "../assets/images/photo3.jpg"


const Gallery = ({ channelData }) => {

  return (
    <div className="photo-area">
            <Carousel>
                <div>
                    <img src={image1}/>
                    <p className="legend">Sizzler in Dosa Tawa</p>
                </div>
                <div>
                    <img src={image2}/>
                    <p className="legend">Healthy Egg Bhuji For Breakfast</p>
                </div>
                <div>
                    <img src={image3} />
                    <p className="legend">Authentic Traditional Chicken Korma</p>
                </div>
            </Carousel>
    </div>
  );
}

export default Gallery;
